// import React, { useState } from "react";
import { deviceAddSelfRouteConfig } from "./routeConfig";
import { LazyRouteList } from "../../components/router/LazyRouteList";
// import { useTheme } from "reactPath/utils/hooks/useTheme";
// import GlobalContext, {
//   GlobalContextProps,
// } from "reactPath/globalContext/globalContext";
// import { useSelector } from "react-redux";
// import DeviceSettingContext from "./context";

const Router = ({ mainUrl }: { mainUrl?: string }) => {
  // const darkTheme = useTheme();
  // const locale = useSelector(
  //   (state: { locale: { message: GlobalContextProps["locale"] } }) =>
  //     state.locale.message
  // );

  return (
      <LazyRouteList
        routeConfig={deviceAddSelfRouteConfig}
        rootPath=""
        mainUrl={mainUrl}
      />
  );
};

export default Router;
